export const selectAllProducts = (state) => state.productsReducer.products;
